module.exports = __webpack_public_path__ + "static/img/point.ff4ea315.png";